/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./EnTeam.css";
import { Link } from "react-router-dom";
import { renderHomePageHeader } from "../../assets/component/renderHomePageHeader.js";
import { Helmet } from "react-helmet";
import HomepageMenuEn from "../../assets/component/HomepageMenuEn/HomepageMenuEn.js";

class EnTeam extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  showModal() {
    this.setState({
      showModal: true,
    });
  }

  closeModal() {
    this.setState({
      showModal: false,
    });
  }
  render() {
    return (
      <div className="EnTeam-view">
        <Helmet>
          <title>Founders - CheckPlus</title>
        </Helmet>

        {!!this.state.showModal && (
          <HomepageMenuEn closeModal={this.closeModal} />
        )}
        {renderHomePageHeader(this)}

        <div className="EnTeam-first">
          <div className="EnTeam-heading">Our Founders</div>
        </div>

        <div className="EnTeam-second">
          <div className="EnTeam-centerContainer">
            <div className="EnTeamContainer">
              <div className="EnTeam-edwardPic" />
              <div className="EnTeam-name">
                <strong>Edward Lai</strong> <br />
                Founder, CEO and Chief Design Officer
              </div>

              <Link to="/EnEdward">
                <div className="EnTeam-learnContainer">
                  <div className="EnTeam-learnTxt">Learn More</div>
                  <div className="EnTeam-learnArrow" />
                </div>
              </Link>
            </div>

            <div className="EnTeamContainer">
              <div className="EnTeam-rixPic" />
              <div className="EnTeam-name">
                <strong>Rix Lai</strong> <br /> Founder and Technology Advisor
              </div>

              <Link to="/EnRix">
                <div className="EnTeam-learnContainer">
                  <div className="EnTeam-learnTxt">Learn More</div>
                  <div className="EnTeam-learnArrow" />
                </div>
              </Link>
            </div>
          </div>
        </div>

        <div className="EnTeam-third">
          <div className="EnTeam-thirdTxt">
            <div className="EnTeam-thirdHeading">Our Story</div>
            <p />
            Our two founders have always believed that, with the right
            technologies, all of our lives are going to be so much easier.
          </div>
        </div>

        <div className="EnTeam-fourth">
          <div className="EnTeam-fourthTxt">
            There was one day our two founders were sitting at a cafe lounge and
            discussing how hard it is to make donations in Hong Kong.
          </div>
        </div>

        <div className="EnTeam-fifth">
          <div className="EnTeam-fifthContainer">
            <div className="EnTeam-messageBubble" />

            <div className="EnTeam-fifthTxt">
              As they went and talked to a few nonprofit organizations, they
              finally came to understand the fact that building and maintaining
              an online donation is extremely costly.
            </div>
          </div>
        </div>

        <div className="EnTeam-sixth">
          <div className="EnTeam-sixthContainer">
            <div className="EnTeam-lightBulb" />
            <div className="EnTeam-sixthTxt">
              They asked themselves a question,
              <p />
              <h4>
                “Wouldn’t it be great if there is an online donation management
                tool that does everything a nonprofit would want at an
                affordable price?”
              </h4>
            </div>
          </div>
        </div>

        <div className="EnTeam-seventh">
          <div className="EnTeam-seventhContainer">
            <div className="EnTeam-birthdayIcn" />
            <div className="EnTeam-seventhTxt">
              Therefore, CheckPlus was born with an aim to simplify the entire
              donation process for all nonprofit organizations.
            </div>
          </div>
        </div>

        <div className="EnTeam-eighth">
          <div className="EnTeam-eighthTxt">
            Many have asked why they name their company CheckPlus.
          </div>
        </div>

        <div className="EnTeam-nineth">
          <div className="EnTeam-checkMark" />

          <div className="EnTeam-ninethTxt">
            <div className="EnTeam-ninethHeading">
              CheckPlus is an Expression of Excellence.
            </div>
            <p />
            Our founders believe everything they do at CheckPlus carries the
            same way of thinking. Every product has to have great design, and at
            the same time, everything product has to be easy to use.
          </div>
        </div>

        <div className="EnTeam-tenth">
          <div className="EnTeam-tenthContainer">
            <div className="EnTeam-tenthIcn" />

            <div className="EnTeam-tenthTxt">
              <div className="EnTeam-tenthHeading">
                The Inspiration of Our Logo
              </div>
              <p />
              Our founders wants the logo to be very simple, and yet, it has to
              be easy for people to recognize with meaning.
              <p />
              CheckPlus is a technology driven company and code is how apps
              communicate. Not only does play a prominent role in the logo,
              there are in fact two Cs as well. Finally, our logo also
              represents a symbol of linkage like a blockchain and a stream of
              river that flows without an end.
            </div>
          </div>
        </div>

        <div className="EnTeam-footer">
          <div className="EnTeam-footerNav">
            <Link to="/EnTeam">
              <div className="EnTeam-footerNavItem">Our Founders</div>
            </Link>
            <Link to="/EnFaq">
              <div className="EnTeam-footerNavItem">FAQ</div>
            </Link>
            <Link to="/EnContact">
              <div className="EnTeam-footerNavItem">Contact Us</div>
            </Link>

            <Link to="/EnPrivacyPolicy">
              <div className="EnTeam-footerNavItem">Privacy Policy</div>
            </Link>

            <Link to="/EnTerms">
              <div className="En-footerNavItem">Terms and Conditions</div>
            </Link>
          </div>

          <div className="EnTeam-footer_text">
            Flat A, 5/F, Wah Lee Industrial Building
            <br />
            11 Sze Shan Street, Yau Tong, Kowloon, Hong Kong
            <br />
            <p />
            Copyright © 2026 CheckPlus Ltd. All Rights Reserved.
          </div>
        </div>
      </div>
    );
  }
}

export default EnTeam;
